const METADATA = {
  TITLE: "dev portfolio", // Website title
  HEADER: "dev portfolio", // Main header
  SUBTITLE: "developer. human.", // Main header subtitle
  DESCRIPTION: "developer portfolio", // Site description
  PROJECTS_TITLE: "Open Source Projects", // Title for projects section
};

export const settings = {
  HIDE_DISABLED: false, // toggle this to hide disabled skill boxes
};

export default METADATA;
